import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import './AskTheExpert.css';

import { Footer } from "../../components/footer/footer";
import Googleadshorizontal from "../../components/google-AdSense/Googleadshorizontal";
import Navbarr from "../../components/header/Navbarr";
import ScrollButton from "../../components/scrollbutton/ScrollButton";
import Subheader from "../../components/subheader/Subheader";
import { Errormsg } from '../../components/tostifymsg/Errrormsg';
import { Succesmsg } from '../../components/tostifymsg/Succesmsg';
import { postMessage } from '../../api/handleapi';

function AskTheExpert () {

	const [formData, setFormData] = useState({
		name: '',
		lastName: '',
		email: '',
		description: ''
	});

	const handlerSendAsk = async () => {
		console.log('formData ::', formData);

		try {
			if (!formData.name || !formData.lastName || !formData.email || !formData.description) {
				throw new Error('Please fill in all fields.');
			}

			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (!emailRegex.test(formData.email)) {
				throw new Error('Please enter a valid email address.');
			}

			await postMessage({
				UserEmail: formData.email,
				UserName: formData.name + ' ' + formData.lastName,
				Message: formData.description,
			});

			setFormData({
				name: '',
				lastName: '',
				email: '',
				description: ''
			});

			Succesmsg('Your message has been sent successfully!');
		} catch (error) {
      Errormsg(error.message);
		}
	}

	return (
		<div>
      <Navbarr/>

      <div className="after-nav-dsubheader containers con_div">
        <Googleadshorizontal props="mt-2 mb-2 text-center"/>
        <Subheader />
				
				<div className='h-100 min-vh-100'>
					<h3 className='mt-4 text-white fw-bold text-center'>
						Ask The Experts
					</h3>

					<div className='container'>
						<div className='w-75 mx-auto p-4 rounded-3 mt-4 mb-5'>
							<div className='mt-4 mb-5'>
								<div className="row">
									<div className="col-md-6">
										<div className='form-group input-group-custom'>
											<label htmlFor="">First Name</label>
											<input type="text" className='form-control' name='name' value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
										</div>
									</div>
									<div className="col-md-6">
										<div className='form-group input-group-custom'>
											<label htmlFor="">Last Name</label>
											<input type="text" className='form-control' name='lastName' value={formData.lastName} onChange={e => setFormData({ ...formData, lastName: e.target.value })} />
										</div>
									</div>
								</div>

								<div className="row">
									<div className="col-md-12">
										<div className='form-group input-group-custom mt-3'>
											<label htmlFor="">Email</label>
											<input type="email" className='form-control' name='email' value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} />
										</div>
									</div>
								</div>

								<div className="row mt-4">
									<div className="col-md-12">
										<div className='form-group input-group-custom'>
											<label htmlFor="">Ask the experts!</label>
											<textarea 
												name="description"
												rows="6"
												value={formData.description}
												onChange={e => setFormData({ ...formData, description: e.target.value })}
											></textarea>
										</div>
									</div>
								</div>


								<div className='text-center mt-4'>
									<button className='btn btn-primary px-4 py-2 fw-bold transparent-bg' onClick={handlerSendAsk}>
										Submit
									</button>
								</div>

							</div>
						</div>
					</div>

				</div>
      </div>

      <Footer />
      <ScrollButton />
    </div>
	);
}

export default AskTheExpert;